var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "#878787",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0571 0C9.12804 0 5.11422 4.01382 5.11422 8.94289C5.11422 10.4366 5.47967 11.8437 6.12875 13.081C6.60615 13.9911 6.57289 15.1416 5.8462 15.8683L0.642769 21.0717C0.287777 21.4267 0.287778 22.0022 0.64277 22.3572C0.997763 22.7122 1.57332 22.7122 1.92831 22.3572L7.13175 17.1538C7.85843 16.4271 9.00889 16.3938 9.91896 16.8712C11.1563 17.5203 12.5634 17.8858 14.0571 17.8858C18.9862 17.8858 23 13.872 23 8.94289C23 4.01382 18.9862 0 14.0571 0ZM14.0571 1.78858C18.0185 1.78858 21.2114 4.98147 21.2114 8.94289C21.2114 12.9043 18.0185 16.0972 14.0571 16.0972C10.0957 16.0972 6.90279 12.9043 6.90279 8.94289C6.90279 4.98147 10.0957 1.78858 14.0571 1.78858Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.76ef4f6c01ac3a27e4d43160076aa13d.svg";
export { ForwardRef as ReactComponent };